import { render } from "./SelectSizeM.vue?vue&type=template&id=f7aea5a6"
import script from "./SelectSizeM.vue?vue&type=script&lang=js"
export * from "./SelectSizeM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v2/SelectSizeM.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7aea5a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7aea5a6', __exports__)) {
    api.reload('f7aea5a6', __exports__)
  }
  
  module.hot.accept("./SelectSizeM.vue?vue&type=template&id=f7aea5a6", () => {
    api.rerender('f7aea5a6', render)
  })

}


export default __exports__